import Cookie from 'js-cookie';
import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';
import nodeFetch from 'node-fetch';

const feathers = require('@feathersjs/feathers');
// const socketio = require('@feathersjs/socketio-client');
const rest = require('@feathersjs/rest-client');
// const io = require('socket.io-client');
const auth = require('@feathersjs/authentication-client');

// const socket = io({
//   transports: ['websocket'],
//   upgrade: false,
// });

const app = feathers();

// // Setup the transport (Rest, Socket, etc.) here
// app.configure(socketio(socket, {
//   timeout: 30000,
// }));
// Connect to the same as the browser URL (only in the browser)
const restClient = rest();

// Configure an AJAX library (see below) with that client
app.configure(restClient.fetch(typeof window !== 'undefined' ? window.fetch : nodeFetch));

// Available options are listed in the "Options" section
export const storageKey = 'auth';
app.configure(auth({
  storageKey,
}));

export const getTokenExpireDate = () => {
  const token = localStorage.getItem('auth');
  if (!token) {
    return null;
  }
  const decoded = jwtDecode(token);
  const { exp } = decoded;
  return dayjs.unix(exp).format('YYYY-MM-DD HH:mm:ss');
};
export const initLogin = (token) => {
  try {
    const decoded = jwtDecode(token);
    const { exp, iat } = decoded;
    const expires = exp - iat;
    const expiresDay = expires / 86400;
    Cookie.set(storageKey, token, { expires: expiresDay });
  } catch (err) {
    app.logout();
  }
};
app.on('login', (authResult) => {
  initLogin(authResult.accessToken);
});

app.on('logout', () => {
  Cookie.remove(storageKey);
});

app.hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },

  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },

  error: {
    all: [
      async (context) => {
        const { code } = context.error;
        if (code === 401 && ['/login', '/logout'].indexOf(window.location.pathname) === -1) {
          window.location = '/logout';
        }
        return context;
      },
    ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
});

const handleError = (error) => {
  if (typeof window === 'undefined') {
    return { data: null, error: null };
  }
  const accessToken = window.localStorage.getItem('feathers-jwt');
  if (!accessToken) {
    // forceLogout();
  }
  if (accessToken && (error.message.search('jwt') !== -1 || error.message.search('Invalid token') !== -1)) {
    // forceLogout();
  } else if (accessToken && error.message.search('No auth') !== -1 && window.location.pathname !== '/login') {
    window.location.reload();
  }
  return { data: null, error };
};

export function service(name) {
  return {
    ...app.service(name),
    find: async (params) => {
      const sv = app.service(name);
      try {
        const data = await sv.find(params);
        return { data, error: null };
      } catch (error) {
        return handleError(error);
      }
    },
    get: async (id, params) => {
      const sv = app.service(name);
      try {
        const data = await sv.get(id, params);
        return { data, error: null };
      } catch (error) {
        return handleError(error);
      }
    },
    create: async (data, params) => {
      const sv = app.service(name);
      try {
        const result = await sv.create(data, params);
        return { data: result, error: null };
      } catch (error) {
        return handleError(error);
      }
    },
    update: async (id, data, params) => {
      const sv = app.service(name);
      try {
        const result = await sv.update(id, data, params);
        return { data: result, error: null };
      } catch (error) {
        return handleError(error);
      }
    },
    patch: async (id, data, params) => {
      const sv = app.service(name);
      try {
        const result = await sv.patch(id, data, params);
        return { data: result, error: null };
      } catch (error) {
        return handleError(error);
      }
    },
    remove: async (id, params) => {
      const sv = app.service(name);
      try {
        const result = await sv.remove(id, params);
        return { data: result, error: null };
      } catch (error) {
        return handleError(error);
      }
    },
  };
}

export default app;
